(function () {
  function initPicker(root) {
    if (!root || root.dataset.rpInit) return;
    root.dataset.rpInit = '1';

    var BTN_LABEL = root.getAttribute('data-button-label') || 'Continue';
    var SUBSCRIBER_ID = root.getAttribute('data-subscriber-id') || '';
    var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var LOCALE = (window.Shopify && Shopify.locale) ? Shopify.locale : 'en';

    var input = root.querySelector('.rp-search');
    var list = root.querySelector('.rp-list');
    var showBtn = root.querySelector('.rp-show');
    var hint = root.querySelector('.rp-hint');
    var status = root.querySelector('.rp-status');
    if (!input || !showBtn) return;

    var selected = null;
    var items = [];
    var activeIndex = -1;
    var debounceTimer = null;

    function setHint(m) { if (hint) hint.textContent = m || ''; }
    function setStatus(html) { if (status) status.innerHTML = html || ''; }
    function openList() { if (list.children.length) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); } }
    function closeList() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); activeIndex = -1; input.removeAttribute('aria-activedescendant'); }
    function stripTags(s) { return (s || '').replace(/<[^>]*>/g, ''); }

    function parseHandle(p) {
      if (p.handle) return p.handle;
      if (p.url) { var m = p.url.split('?')[0].match(/\/products\/([^\/]+)/); if (m) return m[1]; }
      return null;
    }

    function renderList() {
      list.innerHTML = '';
      items.forEach(function (it, i) {
        var li = document.createElement('li');
        li.className = 'rp-option';
        li.setAttribute('role', 'option');
        li.id = (list.id || 'rp-list') + '-opt-' + i;
        li.textContent = it.title;
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(i); });
        list.appendChild(li);
      });
      if (items.length) { openList(); } else { closeList(); }
    }

    function fetchSuggest(q) {
      var url = ROOT_URL + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          items = prods.map(function (p) {
            return { title: stripTags(p.title), handle: parseHandle(p), id: p.id ? String(p.id) : null };
          }).filter(function (it) { return it.handle; });
          renderList();
        })
        .catch(function () { items = []; renderList(); });
    }

    function preResolveId(it) {
      if (!it || it.id) return;
      fetch(ROOT_URL + 'products/' + it.handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { it.id = String(p.id); })
        .catch(function () {});
    }

    function choose(i) {
      var it = items[i];
      if (!it) return;
      selected = it;
      input.value = it.title;
      closeList();
      showBtn.disabled = false;
      setStatus('');
      setHint('Ready — choose “' + BTN_LABEL + '”.');
      preResolveId(selected);
    }

    function move(d) {
      var opts = list.querySelectorAll('.rp-option');
      if (!opts.length) return;
      activeIndex = (activeIndex + d + opts.length) % opts.length;
      opts.forEach(function (o, i) { o.classList.toggle('is-active', i === activeIndex); });
      input.setAttribute('aria-activedescendant', opts[activeIndex].id);
    }

    input.addEventListener('input', function () {
      selected = null;
      showBtn.disabled = true;
      setHint('');
      setStatus('');
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { items = []; closeList(); return; }
      debounceTimer = setTimeout(function () { fetchSuggest(q); }, 200);
    });
    input.addEventListener('focus', function () { if (items.length) openList(); });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') { if (activeIndex >= 0) { e.preventDefault(); choose(activeIndex); } }
      else if (e.key === 'Escape') { closeList(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeList();
    });

    function productPageHref() { return ROOT_URL + 'products/' + selected.handle; }

    function formUrl(id) {
      return 'https://okendo.reviews/?subscriberId=' + encodeURIComponent(SUBSCRIBER_ID) +
        '&productId=' + encodeURIComponent('shopify-' + id) +
        '&locale=' + encodeURIComponent(LOCALE);
    }

    function openReviewForm(id) {
      if (!SUBSCRIBER_ID) {
        setHint('');
        setStatus('<a href="' + productPageHref() + '">Open ' + stripTags(selected.title) + ' to write your review →</a>');
        return;
      }
      var url = formUrl(id);
      var win = window.open(url, '_blank', 'noopener');
      if (win) {
        setHint('Opening the review form in a new tab…');
        setStatus('<a href="' + url + '" target="_blank" rel="noopener">Didn’t open? Open the review form →</a>');
      } else {
        setHint('');
        setStatus('<a href="' + url + '" target="_blank" rel="noopener">Open the review form →</a>');
      }
    }

    showBtn.addEventListener('click', function () {
      if (!selected) return;
      setStatus('');
      if (selected.id) { openReviewForm(selected.id); return; }
      setHint('Opening…');
      fetch(ROOT_URL + 'products/' + selected.handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { selected.id = String(p.id); openReviewForm(selected.id); })
        .catch(function () {
          setHint('');
          setStatus('<a href="' + productPageHref() + '">Open ' + stripTags(selected.title) + ' to write your review →</a>');
        });
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-section-type="review-product-picker"]');
    for (var i = 0; i < nodes.length; i++) initPicker(nodes[i]);
  }

  if (!window.__reviewPickerSetup) {
    window.__reviewPickerSetup = true;
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
